export default __webpack_public_path__ + "static/media/welcome-female@3x.80b18666.png";